import { css } from '@linaria/core';
import { Root as ButtonRoot } from '../../Button/styles';
import { Root as MiniPlayer } from './MiniPlayer/styles';
import { Root as Duration } from './Duration/styles';
import { Root as Link } from './Link/styles';
import { Typo } from '../Typo';
import media from '../Media';
export const transitionDelay = 400; /* Delay for the expanding Hover Animation */
export const ImageContainer = {
    base: css `
		position: relative;
		width: 100%;
		height: 100%;
	`,
    isExpired: css `
		opacity: 0.6;
	`,
    adult: css `
		.${Duration.base}, .${Typo.base} {
			/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
			color: #fff;
		}
	`,
};
export const Label = {
    base: css `
		position: relative;

		display: inline-flex;
		align-items: center;

		padding: var(--label-spacing-padding-tb) var(--label-spacing-padding-lr);
		border-radius: var(--label-corner-radius-all);

		color: rgb(var(--label-color-label-primary));

		background: rgb(var(--label-color-background-primary));

		transition: opacity 200ms var(--global-ease-out);
	`,
};
export const LabelWrapper = {
    base: css `
		display: flex;
		flex-shrink: 0;
		gap: var(--label-spacing-gap-base);

		span:last-of-type {
			margin-right: 0;
		}

		@media (hover: hover) and (pointer: fine) {
			opacity: 0;
		}
	`,
    noSpacing: css `
		margin: 0 !important;
	`,
};
export const BaseContainer = {
    base: css `
		position: relative;
		z-index: 1;

		overflow: hidden;

		border-radius: var(--teaser-corner-radius-teaser);

		background-color: transparent;

		transition: 150ms all var(--global-ease-in-out);

		.${ImageContainer.base} {
			overflow: hidden;
			> div {
				transform: translateZ(0);
			}
			img {
				transition: transform 200ms var(--global-ease-in-out);
			}
		}
		.${LabelWrapper.base} {
			@media (hover: hover) and (pointer: fine) {
				display: none;
			}
		}
		&:focus-within {
			@media (hover: hover) and (pointer: fine) {
				.${MiniPlayer.base} {
					opacity: 1;
				}
			}
		}
	`,
    isFocus: css `
		.${Link.base}, .${Link.base} img {
			outline: 2px solid rgb(var(--teaser-color-base-border-base));
			outline-offset: 2px;
		}
		.${MiniPlayer.base} {
			opacity: 1;
		}
	`,
    isPlaying: css `
		.${MiniPlayer.base} {
			opacity: 1;
		}
	`,
};
export const TopArea = {
    base: css `
		pointer-events: none;

		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;

		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;

		box-sizing: border-box;
		width: 100%;
		padding: var(--teaser-spacing-padding-small) var(--teaser-spacing-padding-small) 0px
			var(--teaser-spacing-padding-small);

		> * {
			align-items: flex-start;
			vertical-align: top;
		}
	`,
    shadow: css `
		background: linear-gradient(
			180deg,
			rgba(var(--teaser-gradient-start-alpha)),
			rgba(var(--teaser-gradient-end-alpha))
		);
	`,
};
export const FromLeft = {
    base: css `
		display: flex;
		flex-direction: row;
		gap: var(--label-spacing-gap-base);
	`,
};
export const FromRight = {
    base: css `
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
	`,
};
export const BottomArea = {
    base: css `
		pointer-events: none;

		position: absolute;
		z-index: 1;
		bottom: 0;
		left: 0;

		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		box-sizing: border-box;
		width: 100%;
		padding: 100px var(--teaser-spacing-padding-small) var(--teaser-spacing-padding-small);

		transition: all 150ms var(--global-ease-in);

		${media('min', 'xl')} {
			padding: 100px var(--teaser-spacing-padding-base) var(--teaser-spacing-padding-base);
		}
	`,
};
export const InfoBg = {
    base: css `
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;

		opacity: 1;
		background-color: rgb(var(--teaser-color-base-background-hover));

		transition-delay: 100ms;
	`,
};
export const SublineWrapper = {
    base: css `
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		width: 100%;

		> div:first-child {
			margin-right: 8px;
		}

		@media (hover: hover) and (pointer: fine) {
			flex-wrap: nowrap;
		}
	`,
};
export const Subline = {
    base: css `
		margin-top: 8px;
	`,
};
export const OverlineWrapper = {
    base: css `
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		width: 100%;
		margin-top: 0.5rem;
		margin-bottom: 6px;

		> div:first-child {
			margin-right: 8px;
		}

		@media (hover: hover) and (pointer: fine) {
			flex-wrap: nowrap;
		}
	`,
};
export const Info = {
    base: css `
		position: relative;
		box-sizing: border-box;
		width: 100%;
		padding: var(--teaser-spacing-padding-small);

		${media('min', 'xl')} {
			padding: var(--teaser-spacing-padding-base);
		}

		@media not all and (hover: hover), not all and (pointer: fine) {
			.${Typo.info01} {
				margin-top: -10px;
				line-height: 48px;
			}
		}
	`,
    hasContextMenuIcon: css `
		@media not all and (hover: hover), not all and (pointer: fine) {
			.${Typo.heading05}, .${Typo.info01} {
				max-width: calc(100% - var(--icon-sizing-icon-xs) - (2 * var(--button-base-spacing-padding-base-lr)));
			}
		}
	`,
    is1x1Ratio: css `
		padding: 10px var(--teaser-spacing-padding-base) var(--teaser-spacing-padding-base)
			var(--teaser-spacing-padding-base);

		h3 {
			-webkit-line-clamp: 3;
		}
		.${SublineWrapper.base} {
			.${Typo.info02} {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				white-space: normal;
			}
		}
	`,
};
export const Description = {
    base: css `
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;

		text-overflow: ellipsis;
		white-space: normal;
	`,
    lines: {
        1: css `
			-webkit-line-clamp: 1;
		`,
        2: css `
			-webkit-line-clamp: 2;
		`,
        3: css `
			-webkit-line-clamp: 3;
		`,
        4: css `
			-webkit-line-clamp: 4;
		`,
        5: css `
			-webkit-line-clamp: 5;
		`,
    },
};
export const ButtonContainer = {
    base: css `
		bottom: 0;

		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-items: flex-start;

		box-sizing: border-box;
		width: 100%;
		padding: 0 var(--teaser-spacing-padding-small) var(--teaser-spacing-padding-small);

		transition: all 0ms;

		${media('min', 'xl')} {
			padding: 0 var(--teaser-spacing-padding-base) var(--teaser-spacing-padding-base);
		}

		> a {
			width: auto !important;
		}

		.${ButtonRoot.base} {
			padding: var(--button-base-spacing-padding-base-tb) 0;
		}
	`,
};
/* HOVER STATE */
export const HoverContainer = {
    base: css `
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;

		overflow: hidden;

		width: 100%;
		height: auto;
		border-radius: var(--teaser-corner-radius-teaser);

		opacity: 0;
		background-color: rgb(var(--teaser-color-base-background-hover));

		transition-delay: 100ms, 50ms, 50ms, 50ms, 3000ms;
		transition-timing-function: var(--global-ease-in-out);
		transition-duration: 150ms, 100ms, 100ms, 100ms, 100ms;
		transition-property: opacity, width, left, top, z-index;

		.${Info.base} {
			height: auto !important;
		}

		.${ImageContainer.base} {
			img {
				transform: scale(1.05);
				transition: transform 200ms var(--global-ease-in-out);
			}
		}
		&.hover {
			z-index: 3;
			top: calc(-10% + 10px);
			left: -10%;

			width: 120%;

			opacity: 1;
			box-shadow:
				0 3px 6px rgba(var(--teaser-shadow-shadow), 0.16),
				0 3px 6px rgba(var(--teaser-shadow-shadow), 0.23);

			transition-delay: ${transitionDelay - 50}ms, ${transitionDelay}ms, ${transitionDelay}ms,
				${transitionDelay}ms, 0ms, ${transitionDelay}ms;
			transition-timing-function: var(--global-ease-in-out);
			transition-duration: 200ms, 200ms, 200ms, 200ms, 0ms, 200ms;
			transition-property: opacity, width, left, top, z-index, box-shadow;

			&.left {
				left: 0;
			}

			&.right {
				left: -20%;
			}

			&.bottom {
				top: -9%;
			}

			.${ImageContainer.base} {
				img {
					transform: scale(1);
					transition-delay: ${transitionDelay}ms;
				}
			}

			.${MiniPlayer.base} {
				opacity: 1;
				transition-delay: 450ms;
				transition-duration: 200ms;
			}
		}
	`,
    isPlaying: css `
		&.hover {
			.${MiniPlayer.base} {
				opacity: 1;
				transition: none;
			}
		}
	`,
};
export const childBorderWithShadow = (color = '--teaser-color-base-border-base') => `
	border-style: solid;
	border-color: rgb(var(${color}));
	border-width: 8px 3px;
	border-top-width: 3px;
`;
export const ChildBaseContainer = {
    base: css `
		${childBorderWithShadow()}

		&&& {
			.${ImageContainer.base} {
				border-radius: 0;
			}
		}
	`,
    modal: css `
		${childBorderWithShadow('--modal-color-border')}
	`,
};
/* HOVER STATE */
export const ChildHoverContainer = {
    base: css `
		${childBorderWithShadow()}
	`,
};
